import Styled from "styled-components";

export const Container = Styled.div`
  width: 100%;
  height: 1040px;
`;

export const ScrollerColumns = Styled.div`
  display: flex;
  flex-flow: column;
  gap: 1.5rem;
  height: 100%;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex-flow: row;
  }
`;

export const ScrollerColumn = Styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  ${(props) => props.theme.breakpoints.up("medium")} {
    width: calc(100% / 2 - 1rem);
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    width: calc(100% / 3 - 1rem);
  }
`;

export const ScrollerOuter = Styled.div`
  height: 100%;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 25%, rgb(0, 0, 0) 75%, rgba(0, 0, 0, 0) 100%);
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 25%, rgb(0, 0, 0) 75%, rgba(0, 0, 0, 0) 100%);
`;

export interface ScrollerInnerProps {
  $animationDuration: number;
}

export const ScrollerInner = Styled.div<ScrollerInnerProps>`
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  gap: 1.5rem;
  animation: ${(props) =>
    `scrollY ${props.$animationDuration}ms linear infinite`};
  transition: animation-duration 2s ease;

  @keyframes scrollY {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(-100%);
    }
  }
`;
